// Chakra imports
import { Icon, Text, Flex, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import {
  IsNotEmpty,
  convertDateToFormattedString,
} from "config/functions";

// Custom components
import OrderStep from "components/dataDisplay/OrderStep";
import IconBox from "components/icons/IconBox";
// Assets
import {
  MdCheckCircle,
  MdCancel,
  MdOutlineAccountCircle,
} from "react-icons/md";
export default function YourOrderSteps(props: {
  statusData?: any;
  dataCadastro?: any;
  [x: string]: any;
}) {
  const { statusData, dataCadastro, ...rest } = props;
  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const brandColor = useColorModeValue("brand.500", "white");
  const completeBg = useColorModeValue(
    "white",
    "linear-gradient(180deg, #1F2A4F 0%, #18224D 50.63%, #111C44 100%)"
  );
  const completeShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "inset 0px 4px 4px rgba(255, 255, 255, 0.2)"
  );
  const incompleteColor = useColorModeValue(
    "secondaryGray.600",
    "whiteAlpha.200"
  );
  const incompleteShadow = useColorModeValue(
    "inset 0px 18px 22px rgba(112, 144, 176, 0.1)",
    "inset 0px 4px 4px #0B1437"
  );
  const lineColor = useColorModeValue("%23BDBDBDFF", "%23BDBDBD1A");

  const refactorStatus = (id: any) => {
    if (statusData?.length > 0) {
      const groupByStatus = statusData.filter(
        (item: any) => item.statusGratuidade?.id === id
      );

      if (IsNotEmpty(groupByStatus)) {
        let firstItem;
        if (id === 1) {
          firstItem = groupByStatus[groupByStatus.length - 1];
        }
        const groupByStatusData = groupByStatus.reduce((a: any, b: any) => {
          return new Date(a.dataInclusao) > new Date(b.dataInclusao) ? a : b;
        });
        switch (id) {
          case 1:
          case statusData.length === 0:
            return (
              <>
                <OrderStep
                  mb={"10px"}
                  name={"Cadastro Iniciado"}
                  date={convertDateToFormattedString(firstItem.dataInclusao)}
                  status={"done"}
                  icon={
                    <IconBox
                      ml={"15px"}
                      h="36px"
                      w="36px"
                      bg={completeBg}
                      boxShadow={completeShadow}
                      icon={
                        <Icon
                          as={MdOutlineAccountCircle}
                          color={brandColor}
                          h="20px"
                          w="20px"
                        />
                      }
                    />
                  }
                />
              </>
            );
          case 3:
            return (
              <OrderStep
                mb={"10px"}
                name={"Gratuidade Concedida"}
                date={convertDateToFormattedString(
                  groupByStatusData.dataInclusao
                )}
                status={"done"}
                icon={
                  <IconBox
                    ml={"15px"}
                    h="36px"
                    w="36px"
                    bg={completeBg}
                    boxShadow={completeShadow}
                    icon={
                      <Icon
                        as={MdCheckCircle}
                        color={brandColor}
                        h="20px"
                        w="20px"
                      />
                    }
                  />
                }
              />
            );
          // case 4:
          //   return (
          //     <OrderStep
          //       name={"Gratuidade Rejeitada/Cancelada"}
          //       date={convertDateToFormattedString(
          //         groupByStatusData.dataInclusao
          //       )}
          //       status={"error"}
          //       icon={
          //         <IconBox
          //           h="36px"
          //           w="36px"
          //           bg={completeBg}
          //           boxShadow={completeShadow}
          //           icon={
          //             <Icon
          //               as={MdCancel}
          //               color={brandColor}
          //               h="20px"
          //               w="20px"
          //             />
          //           }
          //         />
          //       }
          //     />
          //   );

          case 5:
            return (
              <OrderStep
                mb={"10px"}
                name={"Gratuidade Rejeitada/Cancelada"}
                date={convertDateToFormattedString(
                  groupByStatusData.dataInclusao
                )}
                status={"error"}
                icon={
                  <IconBox
                    ml={"15px"}
                    h="36px"
                    w="36px"
                    bg={completeBg}
                    boxShadow={completeShadow}
                    icon={
                      <Icon
                        as={MdCancel}
                        color={brandColor}
                        h="20px"
                        w="20px"
                      />
                    }
                  />
                }
              />
            );

          default:
            break;
        }
      }
    }
  };

  return (
    <Flex flexDirection="column" w="100%" pb="20px" {...rest}>
      <Text color={textColor} fontSize="2xl" fontWeight="700" mb="20px">
        Status da Solicitação
      </Text>
      <Flex position="relative" direction="column">
        <Flex
          position="absolute"
          left="32.5px"
          h="100%"
          w="2px"
          bg={`url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='${lineColor}' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`}
          zIndex={1}
        />

        {/* {IsNotEmpty(statusData) && statusData.length > 0 && (
          <OrderStep
            mb={"10px"}
            name={"Cadastro Iniciado"}
            date={convertDateToFormattedString(dataCadastro)}
            status={"done"}
            icon={
              <IconBox
                ml={"15px"}
                h="36px"
                w="36px"
                bg={completeBg}
                boxShadow={completeShadow}
                icon={
                  <Icon
                    as={MdOutlineAccountCircle}
                    color={brandColor}
                    h="20px"
                    w="20px"
                  />
                }
              />
            }
          />
        )} */}

        {refactorStatus(1)}
        {refactorStatus(2)}
        {refactorStatus(3)}
        {refactorStatus(4)}
        {refactorStatus(5)}
      </Flex>
    </Flex>
  );
}
